import { Stack, SxProps, Theme, Typography } from "@mui/material";

interface CPTitleProps {
  title: string;
  boldTitle?: string;
  hint?: string;
  className?: string;
  sx?: SxProps<Theme>;
}

export const CPTitle = ({
  title,
  boldTitle = '',
  hint,
  className,
  sx
}: CPTitleProps) => {
  return (
    <Stack className={className} spacing={0.5} sx={sx}>
      <Typography fontSize={24} fontWeight={500}>
        {title + " "}

        {/* 15 is hard-coded value. I cannt find better way to break word if it is too long */}
        {boldTitle.length > 15 && <br /> }

        <b>{boldTitle}</b>
      </Typography>
      {hint && (
        <span className="cp-hint" style={{ paddingTop: 0}}>
          <span dangerouslySetInnerHTML={{ __html: hint }} />
        </span>
      )}
    </Stack>
  );
};
